
      // Only register service worker in production
      if ('serviceWorker' in navigator && window.location.hostname !== 'localhost') {
        window.addEventListener('load', () => {
          // Check if we need to update the service worker
          const currentVersion = '${BUILD_TIME}'; // This will be replaced by Vite
          
          navigator.serviceWorker.register('/sw.js?v=' + currentVersion)
            .then(registration => {
              console.log('ServiceWorker registration successful');
              
              // Check for updates
              registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    // New service worker available - force reload
                    window.location.reload();
                  }
                });
              });
            })
            .catch(err => {
              console.log('ServiceWorker registration failed: ', err);
            });
        });
      }
    